module.exports = __webpack_public_path__ + "img/ic-nnext.b66a65bc.svg";